import request from '@/API/request';

// 创建供需信息
export function createPublish(data) {
  return request({
    url: 'resource/api/publish',
    method: 'post',
    data,
  });
}

// 获取供需信息
export function getPublish(data) {
  return request({
    url: 'resource/api/publish/list/pagedata',
    method: 'get',
    params: data,
  });
}

// 上传模板

export function uploadTemplate(data) {
  return request({
    url: "resource/api/data/publish-info/import",
    method: "post",
    headers: {
      'Content-Type': 'multipart/form-data'  // 必须设置这个请求头
    },
    data
  });
}